
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    PatientIdentifier
} from './patientidentifier';

export const identifierstate = (
    context: any,
    initial?:PatientIdentifier[],
) => {
    const initValue = initial || [];

    return (
        state: PatientIdentifier[] = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
       
        let updated = state;
        switch (type) {
            case SET:
                updated = payload
                break;

            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};
